import React, { useEffect, useState } from "react";
import CourseHero from "./components/CourseHero";
import HtmlHead from "../components/html-head/HtmlHead";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import RightMenu from "./components/RightMenu";
import { useDispatch, useSelector } from "react-redux";
import { setIsOpenRightMenu } from "../store/reducers/menuReducer";
import OrderModal from "./components/OrderModal";
import ModalComponent from "./components/ModalComponent";
import Header from "../components/layaut/Header";
import Marquee from "../components/marquee/Marquee";
import useWindowSize from "../components/hooks/useWindowSize";
import { resolveApiAssetUrl } from "../helpers/services/apiSrevice";

const MamaDaiView = ({ courseData, getCourseById }) => {

    const dispatch = useDispatch();
    const windowSize = useWindowSize();
    const navigate = useNavigate();
    const { user } = useSelector(state => state.user);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [courseInfo, setCourseInfo] = useState(null);
    const title = courseData.title || "";
    const description = "";
    const gifSrc = resolveApiAssetUrl(courseData.gifFile || courseData.gifFilePath) || "/gif/mama-dai.gif";

    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isModalOpen]);

    function decodeHtmlEntities(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    return <div className="mama-dai-view">
        <HtmlHead title={title} description={description} />
        <OrderModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            courseData={courseData}
            getCourseById={getCourseById}
        />
        <ModalComponent isOpen={courseInfo ? true : false} onClose={() => setCourseInfo(null)} contentClassName="course-info-scroll">
            {
                courseInfo && courseInfo.courseInfoContents && courseInfo.courseInfoContents.length ?
                    courseInfo.courseInfoContents.map((el, idx) => {
                        return <div key={idx} className={`${idx % 2 === 0 ? "bg-white" : "bg-light-green"} radius-20`}>
                            <div className="course-info-modal" dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(el.textData) }}></div>
                        </div>
                    })
                    : null
            }
        </ModalComponent>
        <RightMenu>
            <div>
                {
                    courseData.courseInfos && courseData.courseInfos.length ?
                        courseData.courseInfos.map((item, index) => {
                            return <Link
                                to="#"
                                key={index}
                                className="link"
                                onClick={() => {
                                    if (item && item.courseInfoContents && item.courseInfoContents.length) {
                                        setCourseInfo(item);
                                    } else if (item.link) {
                                        window.open(item.link, "_blank")
                                    }
                                }}
                            >
                                {item.title}
                            </Link>
                        })
                        : null
                }
            </div>
        </RightMenu>

        <Header>
            <div className="w-100 d-flex">
                <div className="d-flex justify-content-center w-100 gap-3">
                    {
                        courseData.courseInfos && courseData.courseInfos.length ?
                            courseData.courseInfos.map((item, index) => {
                                return <Link
                                    to="#"
                                    key={index}
                                    className={`header-button text-nowrap ${item.isActive ? "active" : ""}`}
                                    onClick={() => {
                                        if (item && item.courseInfoContents && item.courseInfoContents.length) {
                                            setCourseInfo(item);
                                        } else if (item.link) {
                                            window.open(item.link, "_blank");
                                        }
                                    }}
                                >
                                    {item.title}
                                </Link>
                            })
                            : null
                    }
                </div>
            </div>
        </Header>

        <CourseHero
            titleLeft={false}
            title={courseData.title}
            summary={[courseData.miniDescription, courseData.eligibility].filter(Boolean).join(" ")}
            slogan={courseData.slogan}
            mediaSrc={gifSrc}
            fallbackSrc="/gif/mama-dai.gif"
            cta={<>
                    {
                        courseData.isBelongToUser ?
                            <button className="price-button radius-100" onClick={() => navigate(`/course-content/${courseData.id}`)}>
                                К КУРСУ
                            </button>
                            : <button className="price-button radius-100" onClick={() => setIsModalOpen(true)}>
                                {/* КУПИТЬ ЗА {courseData?.ongoingDiscount && courseData?.ongoingDiscount?.discountedPrice ? courseData?.ongoingDiscount?.discountedPrice : courseData.basePrice} */}
                                КУПИТЬ ЗА {courseData?.finalPrice}
                                {
                                    courseData?.ongoingDiscount ?
                                        <b className="discount">
                                            -{courseData?.ongoingDiscount?.discountPercentage}%
                                        </b>
                                        : null
                                }
                                {
                                    courseData?.ongoingDiscount ?
                                        <div className="old-price-block">
                                            <div className="old-price d-flex align-items-center">
                                                <b>{courseData?.basePrice}</b>
                                            </div>
                                        </div>
                                        : null
                                }
                            </button>
                    }
            </>}
        />

        <div className="bottom-block">
            <Container>
                <Row className="position-relative">
                    <Col md={7}>
                        <div className="text mt-3">
                            <div dangerouslySetInnerHTML={{ __html: courseData.description }}></div>
                        </div></Col>
                    <Col md={5} className="image-col">
                        <div className="image-block">
                            <img src="/images/mama-dai-main.svg" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        <Marquee
            content={windowSize.width > 1024 ? ["логопед-дефектолог", "наталья смагина", "логопед-дефектолог", "наталья смагина"] : ["логопед-дефектолог", "Наталья Смагина"]}
            blockClassName="dark-bg"
        />
    </div >
}

export default MamaDaiView
